import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./AlotUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import PinIcon from "../../Assets/Images/Sustenance/pinIcon.svg";
import { Card } from "@mui/material";
//
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import Datagrid from "../../Subcomponents/Datagrid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
//Icons
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { errorTost, infoTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";

import {
  setAlotSustenanceLead,
  setAlotEventLead,
  setAlotEventGlobalLeadAvailable,
  setAlotSustananceGlobalRoute,
} from "../../Services/StoredSessionData";
import { getSpecificEvents } from "../../Services/AlotUnit";
//tokens for events
import { getAllotmentPaymentCheck, getSelectedToken } from "../../Services/AssignNewToken";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { Network } from "@capacitor/network";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    // color: "#667085",
    marginBottom: "3.2rem",
    color: " #000000",
    textTransform: "capitalize",
  },
  projectAddress: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
    // marginLeft: "1rem",
    textTransform: "capitalize",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
}));

export default function AlotUnit({ open, handleClose, returnRes, data, oldAllotmentData, backArrowShow = null, isPaymentTab = false }) {
  const classes = useStyles();
  const navigate = useNavigate();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [hideChoices, setHideChoices] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showEvent, setShowEvent] = useState(null);
  const [tokenAvailable, setTokenAvailable] = useState([]);
  const [selectedToken, setSelectedToken] = useState(null);
  const [showAllTokens, setShowAllTokens] = useState(null);
  const [numberNext, setNumberNext] = useState(0);
  const [totalSteps, setTotalSteps] = useState(2);
  function closeModal() {
    handleClose();
  }
  useEffect(() => {
    console.log(numberNext);
  }, [numberNext]);

  function getEvent() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getSpecificEvents(loggedInUser.userId)
          .then((eventResp) => {
            console.log(eventResp);
            eventResp.data = eventResp.data.map((eachEvent, index) => ({
              ...eachEvent,
              index: index,
              eventId: eachEvent.eventid,
              eventName: eachEvent.eventname,
              launchName: eachEvent.launchname,
              bannerImageUrl: eachEvent.bannerimgurl,
              projectName: eachEvent.projectname,
              projectId: eachEvent.projectid,
              created_at: eachEvent.created_at,
              projectAddress:
                eachEvent.addressline1 +
                eachEvent.addressline2 +
                eachEvent.addressline3,
              isSelected: false,
            }));
            setEvents(eventResp.data);
            if (eventResp.count > 0) {
              setShowEvent(true);
            } else {
              setShowEvent(false);
            }
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }
  function checkTokenTakenForThatEvent() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getSelectedToken(data.leadId, selectedEvent.eventId, isPaymentTab)
          .then((resp) => {
            console.log("resp", resp)
            resp.data.forEach((el) => {
              let date = new Date(el.created_at);
              let tokenExpire = date.setDate(
                date.getDate() + el.eventTokenId.tokenId.validity
              );
              let validUpto = new Date(tokenExpire);
              validUpto = new Date(tokenExpire);
              el.expirationDate = validUpto > Date.now() ? validUpto : "expired";
            })
            resp.data = resp.data.filter(({ expirationDate }) => expirationDate !== 'expired');
            resp = resp.data.map((el) => ({
              ...el,
              isSelected: false,

            }));
            if (resp.length > 0) {
              setShowAllTokens(true);
              setShowEvent(false);
            } else {
              setTokenAvailable([]);
              setSelectedToken(null);
              setShowAllTokens(false);
            }
            setTokenAvailable([...resp]);
            console.log("tokenTaken", resp);
            if (resp.length > 0) {
              // let sendData = {
              //   ...data,
              //   ...selectedEvent,
              // };
              // setAlotEventLead(sendData);
              // setAlotEventGlobalLeadAvailable(true);
              // navigate(
              //   `/home/Event/Details/${selectedEvent.eventName}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectName}`
              // );
            } else {
              // if (selectedEvent.allowleadswithouttoken) {
              //   let sendData = {
              //     ...data,
              //     ...selectedEvent,
              //   };
              // setAlotEventLead(sendData);
              // setAlotEventGlobalLeadAvailable(true);
              // navigate(
              //   `/home/Event/Details/${selectedEvent.eventName}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectName}`
              // );
              // } else {
              //   errorTost("Please buy token for this event first");
              // }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Alot Unit</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          {backArrowShow && !hideChoices && (
            <ArrowBackIcon sx={{ fontSize: "2.4rem", position: 'absolute', left: '2rem', cursor: 'pointer' }} onClick={() => {
              returnRes('back');
              handleClose();
            }} />
          )}
          {hideChoices === false && (
            <div className={cssClasses.content}>
              <div
                className={cssClasses.wrapperEventBlock}
                onClick={() => {
                  setHideChoices(true);
                  getEvent();
                  setNumberNext(0);
                }}
              >
                <div className={cssClasses.imageWrapper}>
                  <ImageOutlinedIcon sx={{ fontSize: "6rem" }} />
                </div>
                <p className={cssClasses.titleEvent}>Events</p>
                <ArrowCircleRightOutlinedIcon sx={{ fontSize: "4rem" }} />
              </div>
              <div
                className={cssClasses.wrapperEventBlock}
                onClick={() => {
                  navigate("/home/Sustenance/");
                  setAlotSustenanceLead({ ...data, ...{ oldAllotmentData } });
                  setAlotSustananceGlobalRoute(true);
                }}
              >
                <div className={cssClasses.imageWrapper}>
                  <ImageOutlinedIcon sx={{ fontSize: "6rem" }} />
                </div>
                <p className={cssClasses.titleEvent}>Sustenance</p>
                <ArrowCircleRightOutlinedIcon sx={{ fontSize: "4rem" }} />
              </div>
            </div>
          )}
          {numberNext === 0 && (
            <div className={cssClasses.tokenTable}>
              {showEvent && (
                <div className={cssClasses.blockLabel}>
                  Select Event <span style={{ color: "red" }}> *</span>
                </div>
              )}

              <div className={cssClasses.wrapperTable}>
                {showEvent &&
                  events.map((eachEvent, index) => {
                    return (
                      <Card className={cssClasses.tokenCard}>
                        <div>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  color: "#155EEF !important",
                                  fontSize: "2rem !important",
                                },
                              }}
                              value={eachEvent.isSelected}
                              onChange={(e) => {
                                // setTokenAvailable([]);
                                setSelectedToken(null);
                                setShowAllTokens(null);
                                setEvents((pre) => {
                                  pre = pre.map((m) => ({
                                    ...m,
                                    isSelected: false,
                                  }));
                                  console.log(pre);
                                  pre[index].isSelected = true;
                                  return [...pre];
                                });

                                console.log(eachEvent);
                                setSelectedEvent(eachEvent);
                              }}
                            >
                              <FormControlLabel
                                className={classes.radioLabel}
                                value={true}
                                control={<Radio />}
                                label={
                                  <div className={classes.radioLabel}></div>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                        <div className={cssClasses.labelValue}>
                          <div>
                            <span
                              className={classes.labelValue}
                              style={{ fontSize: "1.6rem" }}
                            >
                              {eachEvent?.eventName}
                            </span>
                          </div>
                          <div>
                            <span className={classes.labelValue}>
                              {eachEvent.launchName}
                            </span>
                          </div>
                          <div>
                            <span
                              className={classes.labelValue}
                              style={{ marginRight: "1rem" }}
                            >
                              {eachEvent?.projectName}
                            </span>
                            {/* | */}
                            {/* <span className={classes.projectAddress}>
                              {eachEvent.projectAddress}
                            </span> */}
                          </div>
                          <div>
                            <span className={classes.projectAddress}>
                              {eachEvent.projectAddress}
                            </span>
                          </div>
                        </div>
                      </Card>
                    );
                  })}
                {showEvent === false && (
                  <div className={cssClasses.noDataAvailable}>
                    No access to select Events
                  </div>
                )}
              </div>
            </div>
          )}
          {numberNext === 1 && (
            <div className={cssClasses.tokenTable}>
              {showAllTokens && (
                <div className={cssClasses.blockLabel}>
                  Select Token <span style={{ color: "red" }}> *</span>
                </div>
              )}

              <div className={cssClasses.wrapperTable}>
                {showAllTokens &&
                  tokenAvailable.map((eachToken, index) => {
                    console.log(eachToken);
                    return (
                      <Card className={cssClasses.tokenCard} style={{ flexDirection: 'column', gap: '1rem' }}>
                        <div className={cssClasses.tokenRow}>
                          <div style={{ width: '2rem' }}>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    color: "#155EEF !important",
                                    fontSize: "2rem !important",
                                  },
                                }}
                                value={eachToken.isSelected}
                                onChange={(e) => {
                                  setTokenAvailable((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      isSelected: false,
                                    }));
                                    console.log(pre);
                                    pre[index].isSelected = true;
                                    return [...pre];
                                  });

                                  console.log(eachToken);
                                  setSelectedToken(eachToken);
                                }}
                              >
                                <FormControlLabel
                                  className={classes.radioLabel}
                                  value={true}
                                  control={<Radio />}
                                  label={
                                    <div className={classes.radioLabel}></div>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          <div className={cssClasses.labelValue} style={{ width: 'calc(100% - 2rem)', justifyContent: 'space-between' }}>
                            <div className={cssClasses.tokenLabel}>
                              <div className={classes.labelValue} style={{ fontSize: "1.6rem", marginBottom: 0 }}>
                                VJ{eachToken?.tokenNumber}
                              </div>
                              <span className={classes.labelValue} style={{ color: '#344054', marginBottom: '0' }}>
                                {eachToken?.eventTokenId?.tokenId?.name}
                              </span>
                            </div>
                            <div className={cssClasses.tokenStatus}>
                              {eachToken?.status === "pending" && (
                                <LeadStatusChip
                                  label={eachToken?.status}
                                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                ></LeadStatusChip>
                              )}
                              {eachToken?.status === "partial" && (
                                <LeadStatusChip
                                  label={eachToken?.status}
                                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                ></LeadStatusChip>
                              )}
                              {eachToken?.status === "active" && (
                                <LeadStatusChip
                                  label={eachToken?.status}
                                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                ></LeadStatusChip>
                              )}
                              {eachToken?.status === 'adjusted' && (
                                <LeadStatusChip label={eachToken?.status}
                                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                  style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }} />
                              )}
                            </div>
                            <div>
                              <span className={classes.labelValue}>
                                ₹{eachToken?.paidAmount}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className={cssClasses.tokenRow}>
                          <span className={classes.projectAddress} style={{ marginBottom: 0 }}>
                            Valid Upto: {eachToken?.expirationDate.toDateString()},
                            {new Date(eachToken?.expirationDate).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </span>
                        </div>
                      </Card>
                    );
                  })}
                {showAllTokens === false && (
                  <div className={cssClasses.noDataAvailable}>
                    No Tokens available
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {/* Event Button */}
        {hideChoices && (
          <div className={cssClasses.wrapperFooter}>
            <div>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Back"}
                clicked={() => {
                  let _numberNext = numberNext - 1;
                  console.log(_numberNext);
                  if (_numberNext === -1) {
                    setSelectedEvent(null);
                    setEvents([]);
                    setHideChoices(false);
                    setNumberNext(-1);
                  } else if (_numberNext === 0) {
                    setShowEvent(true);
                    setHideChoices(true);
                    setNumberNext(_numberNext);
                  } else {
                    // selectedEvent(null);
                    // setTokenAvailable([]);
                    // setSelectedToken(null);
                    setHideChoices(true);
                    setNumberNext(_numberNext);
                  }
                }}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Next"}
                clicked={() => {
                  if (numberNext === 0) {
                    if (selectedEvent !== null) {
                      let _numberNext = numberNext + 1;
                      console.log(_numberNext);
                      setNumberNext(_numberNext);
                      if (selectedToken === null) {
                        checkTokenTakenForThatEvent();
                      }
                    } else {
                      errorTost("Please select an event first");
                    }
                  }
                  if (numberNext === 1) {
                    if (selectedToken === null && tokenAvailable.length === 0) {
                      //check for selected event
                      console.log("selected-Event", selectedEvent)
                      if (selectedEvent.allowleadswithouttoken) {
                        //navigate
                        let sendData = {
                          ...data,
                          ...selectedEvent,
                          ...{ oldAllotmentData }
                        };
                        setAlotEventLead(sendData);
                        setAlotEventGlobalLeadAvailable(true);
                        sessionStorage.setItem(
                          "isEventLive",
                          JSON.stringify(true)
                        );
                        navigate(
                          `/home/Event/Details/${selectedEvent.eventName}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectName}`
                        );
                      } else {
                        errorTost("Please buy token first");
                      }
                    } else {
                      if (
                        selectedToken === null &&
                        tokenAvailable.length >= 0
                      ) {
                        errorTost("Please select token first");
                      } else {
                        //when token is selected navigate
                        //!yashaswi changes here.
                        console.log("data , ", selectedToken)
                        // if (selectedToken?.checkpt2 === true) {
                        if (
                          isPaymentTab &&
                          selectedToken?.status === "adjusted"
                        ) {
                          getAllotmentPaymentCheck(
                            selectedToken.paymentId
                          ).then((resp) => {
                            if (resp.data.length > 0) {
                              let sendData = {
                                ...data,
                                ...selectedEvent,
                                ...selectedToken,
                                ...{ oldAllotmentData },
                              };
                              setAlotEventLead(sendData);
                              setAlotEventGlobalLeadAvailable(true);
                              sessionStorage.setItem(
                                "isEventLive",
                                JSON.stringify(true)
                              );
                              navigate(
                                `/home/Event/Details/${selectedEvent.eventId}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectid}`
                              );
                            } else {
                              if (selectedToken.linkedTokenId !== null) {
                                getAllotmentPaymentCheck(
                                  selectedToken.linkedTokenId,
                                ).then((_res) => {
                                  if (_res.data.length > 0) {
                                    let sendData = {
                                      ...data,
                                      ...selectedEvent,
                                      ...selectedToken,
                                      ...{ oldAllotmentData },
                                    };
                                    setAlotEventLead(sendData);
                                    setAlotEventGlobalLeadAvailable(true);
                                    sessionStorage.setItem(
                                      "isEventLive",
                                      JSON.stringify(true)
                                    );
                                    navigate(
                                      `/home/Event/Details/${selectedEvent.eventId}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectid}`
                                    );
                                  } else {
                                    infoTost("Cannot alot new unit because token is adjusted!")
                                  }
                                }).catch((err) => {
                                  console.log('err: ', err);

                                })
                              } else {
                                infoTost("Cannot alot new unit because token is adjusted!")
                              }
                            }
                          }).catch((err) => {
                            console.log('err: ', err);

                          })
                        } else {
                          if (
                            selectedToken?.checkpt2 === true ||
                            (isPaymentTab &&
                              selectedToken?.status === "adjusted")
                          ) {
                            let sendData = {
                              ...data,
                              ...selectedEvent,
                              ...selectedToken,
                              ...{ oldAllotmentData },
                            };
                            setAlotEventLead(sendData);
                            setAlotEventGlobalLeadAvailable(true);
                            sessionStorage.setItem(
                              "isEventLive",
                              JSON.stringify(true)
                            );
                            navigate(
                              `/home/Event/Details/${selectedEvent.eventId}/DirectAllotment/${selectedEvent.launchid}/${selectedEvent.projectid}`
                            );
                          } else {
                            infoTost("Please clear checkpoints to alot unit");
                          }
                        }
                      }
                    }
                  }
                }}
              //   disable={disabeNext}
              />
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
}
